import { suppressKeyboardEventForInput } from 'components/AgGrid/utils';
import { WorkInSumTitles } from 'constantsProject';
import type { WorkOrderChangePriceData, WorkOrderPriceData, WorkOrderChangeStatusEnum } from 'gql/graphql';
import { WorkInSumEnum } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { ColDef, ColGroupDef, GridApi } from 'ag-grid-community';
import { useMemo } from 'react';

import { PassageHeaderComponent } from '../../WorkOrder/WorkOrderPrice/PassageHeaderComponent';
import { WorkRatioEditCellRendererComponent } from '../CellRenderers/WorkRatioEditCellRendererComponent';

interface IUseWorkOrderChangeTypeWorkColumns {
    statusWorkOrderChange?: WorkOrderChangeStatusEnum;
    onWorkRatioEditSuccess: () => void;
}

const cellClass = 'workKind';

export const useWorkOrderChangeTypeWorkColumns = (props: IUseWorkOrderChangeTypeWorkColumns) => {
    const { statusWorkOrderChange, onWorkRatioEditSuccess } = props;

    return useMemo<(ColDef<WorkOrderChangePriceData> | ColGroupDef<WorkOrderChangePriceData>)[]>(
        () => [
            {
                headerName: 'Виды работ',
                field: 'groupName',
                headerClass: `flexStart ${cellClass}`,
                children: [
                    {
                        headerName: 'Шифр',
                        field: 'workCode',
                        width: 136,
                        headerClass: cellClass,
                        cellClass,
                    },
                    {
                        headerName: 'Наименование',
                        field: 'workName',
                        width: 162,
                        headerClass: cellClass,
                        cellClass,
                    },
                    {
                        headerName: 'Ед.изм.',
                        field: 'workUnit',
                        width: 90,
                        headerClass: cellClass,
                        cellClass,
                    },
                    {
                        headerName: 'Участие в суммировании ФО по виду работ',
                        field: 'workInSum',
                        width: 162,
                        headerClass: `noWrap ${cellClass}`,
                        cellClass,
                        valueFormatter: ({ data }) => WorkInSumTitles[data?.workInSum as WorkInSumEnum],
                    },
                    {
                        headerName: 'К перехода',
                        field: 'workRatio',
                        width: 136,
                        headerClass: cellClass,
                        cellClass,
                        valueFormatter: ({ data }) => formatNumberToRu(data?.workRatio, 2),
                        headerComponent: PassageHeaderComponent,
                        headerComponentParams: {
                            checkAlert: (api: GridApi<WorkOrderPriceData>) =>
                                api
                                    .getRenderedNodes()
                                    .some(
                                        (node) =>
                                            (node.data?.workInSum === WorkInSumEnum.ParticipateWithRatio ||
                                                node?.data?.isActKC2Price) &&
                                            !node.data?.workRatio,
                                    ),
                        },
                        cellRenderer: WorkRatioEditCellRendererComponent,
                        cellRendererParams: {
                            onSuccess: onWorkRatioEditSuccess,
                            workOrderStatus: statusWorkOrderChange,
                        },
                        suppressKeyboardEvent: suppressKeyboardEventForInput,
                    },
                    {
                        headerName: 'План (Кол-во)',
                        field: 'workPlan',
                        width: 136,
                        headerClass: cellClass,
                        cellClass,
                        valueFormatter: ({ data }) => formatNumberToRu(data?.workPlan, 3),
                    },
                    {
                        headerName: 'Выполнено (Кол-во)',
                        field: 'workCompleted',
                        width: 136,
                        headerClass: cellClass,
                        cellClass,
                        valueFormatter: ({ data }: any) => formatNumberToRu(data?.workCompleted, 3),
                    },
                    {
                        headerName: 'Остаток (Кол-во)',
                        field: 'workReminder',
                        width: 136,
                        headerClass: cellClass,
                        cellClass,
                        valueFormatter: ({ data }: any) => formatNumberToRu(data?.workReminder, 3),
                    },
                ],
            },
        ],
        [onWorkRatioEditSuccess, statusWorkOrderChange],
    );
};
